import React, { useEffect, useState } from 'react';
import { getClassName,getResName } from './Restrictions';
import { Menu,Table, TableCell, Box,Tooltip,
  TableContainer, TableHead, TableRow, TableBody, Popover } from '@mui/material';
import { isEmptyObj } from '../../app/util';
export default function RestrictionsToolTip(props) {
  let houseItems = props.chipArrAll;
  let {restrictionHouseData, roomTypeRestdata, openToolTip,
    toolTipOpen,anchorEl,setAnchorEl} = props; //props.roomTypeRestdata;  we need to open this when we nee dto show Room type restrictions


  const open = Boolean(toolTipOpen);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

 
  let rmTypeResTable =  roomTypeRestdata.map((item, k) => {
    let chipArray = [];
    if (item['min_los'] <= 1) {
        delete item['min_los']
    }
    if (item['max_los'] <= 1) {
        delete item['max_los']
    }
    let keys = Object.keys(item).filter(i => i !== "stay_date" && 
    i !== "room_type" && i !== "updatedEntry" && i !== "asof_date" && i !== "exceptions")
    const hasExceptions = item.exceptions && Object.keys(item.exceptions).length > 0;
  
    keys.forEach((key, index) => {
        let exceptionsDisplay="";
        if(item[key]){
          let resName = key.toUpperCase();
          let classStyle = getClassName(resName);
          let itemNameDetails = getResName(key,item[key]);
          resName = itemNameDetails.resName;
          
          // Check if this restriction has exceptions
          const displayName = (hasExceptions && !isEmptyObj(item.exceptions[key])) ? `${resName}*` : resName;
          if(hasExceptions && !isEmptyObj(item.exceptions[key])){
            Object.keys(item.exceptions[key]).forEach(exception=>{
              exceptionsDisplay+=exception+": " + item.exceptions[key][exception] +" ";
            })
          
          }
          chipArray.push(
            <Tooltip title={exceptionsDisplay}>
            <div className={"chip " + classStyle}>{displayName}</div>
            </Tooltip>
          )
        }
        
      

    })
    if(chipArray.length>0){
      return (<>
        <TableRow
          sx={{'td, & th': { border: 0, p: 1, fontSize: 12, color: "#333333" } }} // LRV-1134
          //sx={{ '&:first-child td, &:first-child th': { border: 0, pt: 1 }, '&:last-child td, &:last-child th': { border: 0 }, '& td, & th': { border: 0, pt: .6, pb: 0, fontSize: 12, color: "#333333" } }}
        >
          <TableCell component="th" scope="row">
            {item.room_type || props.room_type}
          </TableCell> <TableCell component="th" scope="row">
            {item.room_type || props.room_type}
          </TableCell> <TableCell component="th" scope="row" className='chip-list'>
            {chipArray}
          </TableCell>
        </TableRow>

      </>)
    }
    
  });

  const [arrowTop, setArrowTop] = React.useState("50%");

  React.useEffect(() => {
    if (!anchorEl) return;

    setTimeout(() => {
      const menuElement = document.querySelector('.rateplan-box');
      const menuHeight = menuElement?.offsetHeight || 200;
      const anchorRect = anchorEl.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      const spaceBelow = windowHeight - anchorRect.top;
      const spaceAbove = anchorRect.top;
      const diff = menuHeight / 2 - spaceBelow;

      let newArrowTop = "50%";

      // If the popover is near the top, move the arrow up
      if (spaceAbove < menuHeight / 2) {
        newArrowTop = `${Math.max(25, (spaceBelow / menuHeight) * 100)}%`;
      }
      // If the popover is near the bottom, move the arrow down
      else if (spaceBelow < menuHeight / 2) {
        newArrowTop = diff > 35 ? "70%" : diff > 30 ? "65%" : diff > 25 ? "60%" : diff > 20 ? "58%" : diff > 15 ? "54%" : diff > 5 ? "50%" : "50%";
      }

      console.log("newArrowTop", newArrowTop);
      setArrowTop(newArrowTop);
    }, 0);
  }, [anchorEl, open]);

  // LRV-1134 START
  const [position, setPosition] = useState('left');
  useEffect(() => {
    if (anchorEl) {
      const anchorRect = anchorEl.getBoundingClientRect();
      const viewportWidth = window.innerWidth;
      const spaceLeft = anchorRect.left;
      const spaceRight = viewportWidth - anchorRect.right;

      // If space on left is greater than 300px, show on left; else right
      if (spaceLeft > 300) {
        setPosition('left');
      } else {
        setPosition('right');
      }
    }
  }, [anchorEl]);
  // LRV-1134 END

  return (
    <div className='restrictions-details'>
      <div
        aria-owns={open ? 'mouse-over-popover' : undefined}
        aria-haspopup="true"
        // onClick={handleClick}
        onMouseEnter={openToolTip}
        // onMouseLeave={handleClose}
        style={{cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center" }}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="#606060" viewBox="0 0 256 256"><path d="M144,128a16,16,0,1,1-16-16A16,16,0,0,1,144,128ZM60,112a16,16,0,1,0,16,16A16,16,0,0,0,60,112Zm136,0a16,16,0,1,0,16,16A16,16,0,0,0,196,112Z"></path></svg>      
      </div>
      {/* LRV-1134 START */}
      <Popover
      className='restrictions-details'
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      PaperProps={{
        sx: {
          ml: position === 'left' ? '-4px' : '0px',
          mr: position === 'right' ? '-4px' : '0px',
          width: 'max-content',
          position: 'relative',
          overflow: 'visible',
          '&:before': {
            content: '""',
            display: 'block',
            position: 'absolute',
            left: position === 'right' ? '-11px' : 'unset',
            right: position === 'left' ? '-11px' : 'unset',
            top: '50%',
            width: 0,
            height: 0,
            borderTop: '9px solid transparent',
            borderBottom: '9px solid transparent',
            borderLeft: position === 'left' ? '11px solid #F8F9FA' : 'none',
            borderRight: position === 'right' ? '11px solid #F8F9FA' : 'none',
            transform: 'translateY(-50%)',
            filter: 'drop-shadow(-5px -4px 16px rgba(0, 0, 0, 0.2))',
            zIndex: 1
          }
        },
      }}
      anchorOrigin={{
        vertical: 'center',
        horizontal: position,
      }}
      transformOrigin={{
        vertical: 'center',
        horizontal: position === 'left' ? 'right' : 'left',
      }}
    >
    {/* LRV-1134 END */}

        <Box className='restriction-box'>
          <Box className='restriction-box-title'>Restrictions</Box>
          <Box sx={{ m: .5, overflow: "auto", maxHeight: 170 }}>
            <TableContainer sx={{}}>
              <Table sx={{}}>
                <TableHead>
                  <TableRow className='restriction-table-row' sx={{ '& td, & th': { pt: .5, pb: .2, borderBottom: 1 } }}>
                    <TableCell className='table-heading' sx={{}}>Room Type	</TableCell>
                    <TableCell className='table-heading'>Room Code</TableCell>
                    <TableCell className='table-heading'>Restriction</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody sx={{ overflowX: "hidden", overflowY: "auto" }}>

                 

                  {houseItems.length>0 && ( <TableRow
                    sx={{'td, & th': { border: 0, p: 1, pb: 0, fontSize: 12, color: "#333333" } }} // LRV-1134
                    //sx={{ '&:last-child td, &:last-child th': { border: 0 }, '& td, & th': { border: 0, pt: .6, pb: .8, fontSize: 12, color: "#333333" } }}
                  >
                    <TableCell component="th" scope="row">
                      House
                    </TableCell> <TableCell component="th" scope="row">
                      House
                    </TableCell> <TableCell component="th" scope="row">
                      {houseItems}
                    </TableCell>
                  </TableRow>)}
                  {
                   rmTypeResTable

                  }



                </TableBody>
              </Table></TableContainer>
          </Box>
        </Box>

      </Popover>
    </div >
  );
}